module.exports = __webpack_public_path__ + "img/water_droplet_7.14450d2f.svg";